import { Text, TextProps } from '@chakra-ui/react'

export const StenlundsCompanyInfo = (props: TextProps) => {
  return (
    <Text fontSize="sm" {...props}>
      Stenlunds vitvaror AB
      <br />
      Strömögatan 8<br />
      164 40 Kista
      <br />
      Org.nummer: 559549-5861
    </Text>
  )
}
